<section class="addTransaction w-full max-w-2xl mx-auto px-3 md:px-6 py-6 space-y-6" dir="rtl">

  <header class="flex flex-col gap-1">
    <p class="text-base text-ink-500">בית כנסת</p>
    <h1 class="text-3xl font-bold text-primary-700">{{ header }}</h1>
  </header>

  <form
    novalidate
    [formGroup]="addTransactionForm"
    (ngSubmit)="openConfirm()"
    class="card-2026 space-y-5"
    autocomplete="off"
  >
    <!-- Action type (income / expense) -->
    <div class="form-row-2026">
      <label class="form-row-2026__label" for="txActionType">סוג פעולה</label>
      <select
        id="txActionType"
        class="input-2026"
        formControlName="actionType"
        name="actionType"
      >
        <option value="" disabled>בחר סוג פעולה</option>
        <option value="1">הכנסה</option>
        <option value="2">הוצאה</option>
      </select>
    </div>

    <!-- Expense category (only when actionType = 2) -->
    <div class="form-row-2026" *ngIf="addTransactionForm.get('actionType')?.value === '2'">
      <label class="form-row-2026__label" for="txExpenseType">סוג ההוצאה</label>
      <select
        id="txExpenseType"
        class="input-2026"
        formControlName="expenseType"
        name="expenseType"
      >
        <option value="" disabled>סוג ההוצאה</option>
        <option value="תחזוקה">תחזוקה</option>
        <option value="מלאי">מלאי</option>
        <option value="בעל מקצוע">בעל מקצוע</option>
        <option value="קייטרינג">קייטרינג</option>
        <option value="אחר">אחר</option>
      </select>
    </div>

    <!-- Amount -->
    <div class="form-row-2026">
      <app-money-input
        formControlName="amountPaid"
        label="סכום (₪)"
        [decimals]="2"
        hint="לאגורות הקלידו נקודה, למשל 1250.50"
      ></app-money-input>
    </div>

    <!-- Payment type -->
    <div class="form-row-2026">
      <label class="form-row-2026__label" for="txPaymentType">אמצעי תשלום</label>
      <select
        id="txPaymentType"
        class="input-2026"
        formControlName="paymentType"
        name="paymentType"
      >
        <option value="" disabled>בחר סוג תשלום</option>
        <option value="אשראי">אשראי</option>
        <option value="מזומן">מזומן</option>
        <option value="העברה בנקאית">העברה בנקאית</option>
        <option value="צק">צ'ק</option>
      </select>
    </div>

    <!-- Check number (only when paymentType = צק) -->
    <div class="form-row-2026" *ngIf="addTransactionForm.get('paymentType')?.value === 'צק'">
      <label class="form-row-2026__label" for="txCheckNo">מספר צ'ק</label>
      <input
        id="txCheckNo"
        type="text"
        placeholder="0000123"
        class="input-2026"
        formControlName="checkNo"
        name="checkNo"
      />
    </div>

    <!-- Counterparty -->
    <div class="form-row-2026">
      <label class="form-row-2026__label" for="txPaidTo">
        {{ addTransactionForm.get('actionType')?.value === '1' ? 'מאת' : 'מוטב' }}
      </label>
      <input
        id="txPaidTo"
        type="text"
        placeholder="שם"
        class="input-2026"
        formControlName="paidTo"
        name="paidTo"
      />
    </div>

    <!-- Submit -->
    <div class="pt-2 flex justify-end">
      <button
        type="submit"
        class="btn-2026--primary w-full md:w-auto md:min-w-[200px]"
        [disabled]="loading || addTransactionForm.invalid"
      >
        <span *ngIf="!loading" class="flex items-center gap-2">
          <i class="material-symbols-outlined" aria-hidden="true">add_circle</i>
          {{ addText }}
        </span>
        <span *ngIf="loading" class="flex items-center gap-2">
          <mat-spinner diameter="22"></mat-spinner>
          <span>שומר...</span>
        </span>
      </button>
    </div>
  </form>
</section>

<!-- ── Transaction confirmation dialog ──────────────────────────────── -->
<div
  *ngIf="confirming"
  class="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4"
  role="dialog"
  aria-modal="true"
  aria-labelledby="txConfirmTitle"
  (click)="cancelConfirm()"
  dir="rtl"
>
  <div
    class="bg-surface rounded-2xl shadow-elevated max-w-lg w-full max-h-[90vh] flex flex-col overflow-hidden"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="p-4 bg-primary-500 text-white flex justify-between items-center gap-3">
      <h2 id="txConfirmTitle" class="text-lg font-bold flex items-center gap-2">
        <i class="material-symbols-outlined" aria-hidden="true">fact_check</i>
        אישור פעולה בבית הכנסת
      </h2>
      <button
        type="button"
        (click)="cancelConfirm()"
        class="p-1 hover:bg-white/20 rounded-lg transition-colors"
        aria-label="סגור"
      >
        <i class="material-symbols-outlined" aria-hidden="true">close</i>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto p-4 space-y-4">
      <p class="text-sm text-ink-600">
        בדקו שהפרטים נכונים, ובמיוחד את הסכום, לפני השמירה. הפעולה תעדכן את יתרת בית הכנסת.
      </p>

      <!-- Type + amount -->
      <div class="rounded-xl p-4 text-center border-2"
           [class.border-success]="confirming.actionType === 1"
           [class.bg-success-soft]="confirming.actionType === 1"
           [class.border-danger]="confirming.actionType === 2"
           [class.bg-danger-soft]="confirming.actionType === 2">
        <div class="inline-flex items-center gap-1.5 text-lg font-bold"
             [class.text-success]="confirming.actionType === 1"
             [class.text-danger]="confirming.actionType === 2">
          <i class="material-symbols-outlined" aria-hidden="true">
            {{ confirming.actionType === 1 ? 'south_east' : 'north_west' }}
          </i>
          {{ confirming.actionType === 1 ? 'הכנסה' : 'הוצאה' }}
        </div>
        <div class="text-4xl font-bold text-ink-900 mt-2 money">
          {{ formatAmount(confirming.amountPaid) }}
        </div>
        <!-- Amount in words — a misplaced decimal point is obvious here. -->
        <div *ngIf="confirming.amountWords" class="mt-3 pt-3 border-t border-ink-200">
          <div class="text-sm text-ink-500 font-medium">הסכום במילים</div>
          <div class="text-xl font-semibold text-ink-800 mt-1 leading-snug">
            {{ confirming.amountWords }}
          </div>
        </div>
      </div>

      <!-- Large amount warning -->
      <div *ngIf="isLargeAmount"
           class="rounded-xl p-3 bg-warning-soft border border-warning text-warning font-semibold flex items-start gap-2"
           role="alert">
        <i class="material-symbols-outlined" aria-hidden="true">warning</i>
        <span>סכום גבוה במיוחד. ודאו שהסכום במילים הוא באמת מה שהתכוונתם.</span>
      </div>

      <!-- Details -->
      <dl class="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <dt class="text-sm font-medium text-ink-500">{{ confirming.actionType === 1 ? 'מאת' : 'מוטב' }}</dt>
          <dd class="text-lg font-semibold text-ink-800 mt-0.5">{{ confirming.paidTo }}</dd>
        </div>
        <div>
          <dt class="text-sm font-medium text-ink-500">אמצעי תשלום</dt>
          <dd class="text-lg font-semibold text-ink-800 mt-0.5">{{ confirming.paymentType === 'צק' ? "צ'ק" : confirming.paymentType }}</dd>
        </div>
        <div *ngIf="confirming.checkNo">
          <dt class="text-sm font-medium text-ink-500">מספר צ'ק</dt>
          <dd class="text-lg font-semibold text-ink-800 mt-0.5">{{ confirming.checkNo }}</dd>
        </div>
        <div *ngIf="confirming.expenseType">
          <dt class="text-sm font-medium text-ink-500">סוג ההוצאה</dt>
          <dd class="text-lg font-semibold text-ink-800 mt-0.5">{{ confirming.expenseType }}</dd>
        </div>
      </dl>

      <!-- Balance before → after -->
      <div class="rounded-xl border border-ink-100 overflow-hidden">
        <div class="grid grid-cols-2 divide-x divide-x-reverse divide-ink-100 text-center">
          <div class="p-3">
            <div class="text-xs text-ink-500 font-medium">יתרה עכשיו</div>
            <div class="money text-lg font-bold mt-1">
              <ng-container *ngIf="currentBalance !== null; else balanceWait">
                {{ formatAmount(currentBalance) }}
              </ng-container>
            </div>
          </div>
          <div class="p-3">
            <div class="text-xs text-ink-500 font-medium">יתרה אחרי הפעולה</div>
            <div class="money text-lg font-bold mt-1"
                 [class.money--credit]="confirming.actionType === 1"
                 [class.money--debt]="confirming.actionType === 2">
              <ng-container *ngIf="balanceAfter !== null; else balanceWait">
                {{ formatAmount(balanceAfter) }}
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <ng-template #balanceWait>
        <span *ngIf="balanceLoading" class="skeleton-2026 inline-block h-6 w-24 align-middle"></span>
        <span *ngIf="!balanceLoading" class="text-sm text-ink-500">לא זמין</span>
      </ng-template>
    </div>

    <!-- Footer -->
    <div class="p-4 border-t border-ink-100 bg-bg flex flex-col-reverse sm:flex-row sm:justify-between gap-3">
      <button
        type="button"
        (click)="cancelConfirm()"
        class="btn-2026--ghost w-full sm:flex-1"
        [disabled]="loading"
      >
        ביטול / חזרה לעריכה
      </button>
      <button
        type="button"
        (click)="confirmSubmit()"
        class="btn-2026--primary w-full sm:flex-1"
        [disabled]="loading"
      >
        <span *ngIf="!loading" class="flex items-center gap-2 justify-center">
          <i class="material-symbols-outlined" aria-hidden="true">save</i>
          אישור ושמירה
        </span>
        <span *ngIf="loading" class="flex items-center gap-2 justify-center">
          <mat-spinner diameter="22"></mat-spinner>
          <span>שומר...</span>
        </span>
      </button>
    </div>
  </div>
</div>
